"use client";

import type { HTMLAttributes, ReactNode } from "react";

export type StatusBadgeVariant = "neutral" | "success" | "warning" | "danger";

export interface StatusBadgeProps extends Omit<HTMLAttributes<HTMLSpanElement>, "children"> {
  children: ReactNode;
  variant?: StatusBadgeVariant;
}

const VARIANT_CLASSES: Record<StatusBadgeVariant, string> = {
  neutral: "border-border bg-surface text-text-secondary",
  success: "border-success/30 bg-success-soft text-success-dark",
  warning: "border-warning/30 bg-warning-soft text-warning-dark",
  danger: "border-danger/30 bg-danger-soft text-danger-dark",
};

export function StatusBadge({ variant = "neutral", className, children, ...rest }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${VARIANT_CLASSES[variant]} ${className ?? ""}`}
      {...rest}
    >
      {children}
    </span>
  );
}
